import type { Company } from 'modules/core/hooks/useCurrentSession'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'

export const missingFeatureRequestReason = (company: Company) => {
  return company.subscription.isLegacy
    ? ValidReasons.MissingFeatureLegacy
    : ValidReasons.MissingFeature
}
